import beritaApi from '../../services/beritaApi'

const SET_BERITA = "SET_BERITA"
const SET_BERITA_SHOW = "SET_BERITA_SHOW"

const state = {
	berita: null,
	beritaShow: null
}

const mutations = {
	[SET_BERITA](state, data) {
		state.berita = data
	},
	[SET_BERITA_SHOW](state, data) {
		state.beritaShow = data
	}
}

const actions = {
	async fetchBerita({ commit, getters }, data) {
		let token = getters.getAuthService.token
		return await beritaApi.fetchBerita(token, data)
	},
	async showBerita({ commit, getters }, slug) {
		return await beritaApi.showBerita(slug)
	},
	async showBeritaByAdmin({ commit, getters }, slug) {
		let token = getters.getAuthService.token
		return await beritaApi.showBeritaByAdmin(token, slug)
	},
	setBeritaShow({ commit, getters }, data) {
		commit(SET_BERITA_SHOW, data)
	},
	async fetchBeritaPin({ commit, getters }) {
		return await beritaApi.fetchBeritaPin()
	},
	async fetchBeritaHomepage({ commit, getters }) {
		return await beritaApi.fetchBeritaHomepage()
	},
	async fetchBeritaHeadline({ commit, getters }) {
		return await beritaApi.fetchBeritaHeadline()
	},
	async fetchAllBerita({ commit, getters }, data) {
		return await beritaApi.fetchAllBerita(data)
	},
	async storeBerita({ getters }, data) {
		let token = getters.getAuthService.token
		return await beritaApi.storeBerita(token, data)
	},
	async updateBerita({ getters }, data) {
		let token = getters.getAuthService.token
		return await beritaApi.updateBerita(token, data.id, data.form)
	},
	async deleteBerita({ getters }, id) {
		let token = getters.getAuthService.token
		return await beritaApi.deleteBerita(token, id)
	}
}

const getters = {
	getBerita: state => {
		return state.berita
	},
	getBeritaShow: state => {
		return state.beritaShow
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}